module.exports = __webpack_public_path__ + "assets/img/NT.4dbfd7c2.svg";